import { useState, useRef, useEffect } from 'react';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import { cx } from 'class-variance-authority';
import { comboBoxStyles } from './ComboBox';
import { useClickAway } from 'react-use';

type Props = {
  placeholder?: string;
  isDisabled?: boolean;
  popoverWidth?: string;
  children: React.ReactNode;
  closeSignal?: number;
};

const PopoverBox = ({
  placeholder = 'Select',
  isDisabled = false,
  popoverWidth = "400px",
  children,
  closeSignal,
}: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef(null);

  useClickAway(ref, () => setIsOpen(false));

  const prevSignalRef = useRef<any>();

  useEffect(() => {
    if (closeSignal !== prevSignalRef.current) {
      setIsOpen(false);
      prevSignalRef.current = closeSignal;
    }
  }, [closeSignal]);


  return (
    <div ref={ref} className="relative">
      <button
        type="button"
        disabled={isDisabled}
        onClick={() => setIsOpen((prev) => !prev)}
        className={cx(
          comboBoxStyles({ disabled: isDisabled }),
          'pr-[4rem] truncate overflow-hidden text-ellipsis text-left w-full'
        )}
      >
        {placeholder}
        <span className="absolute inset-y-0 right-[0.8rem] md:right-[2rem] flex items-center pr-2 pointer-events-none">
          <ChevronDownIcon className="h-6 w-6 text-brand-gray" />
        </span>
      </button>

      {isOpen && (
        <div
          className="
            absolute z-overlay mt-2 min-w-[20rem] rounded-[.8rem]
            bg-brand-white shadow-lg ring-1 ring-brand-black
             focus:outline-hidden p-4
          "
          style={{ width: popoverWidth }}
        >
          {children}
        </div>
      )}
    </div>
  );
};

export default PopoverBox;
